export default {
  branding: {
    title: "Identidad visual",
    subtitle: "Personaliza el logo y color principal de tu organización.",
    errImageOnly: "Solo se permiten imágenes (PNG, JPG, WebP, SVG)",
    errTooBig: "El logo no puede superar 2 MB",
    errUploadFailed: "Error al subir el logo",
    saved: "Cambios guardados correctamente",
    logo: "Logo",
    logoHelp: "Se mostrará en el sidebar en lugar del logo de HelixScan. PNG, JPG, WebP o SVG · Máx. 2 MB · Recomendado: fondo transparente, relación 4:1.",
    logoPreviewAlt: "Vista previa del logo",
    dropLine1: "Arrastra o haz clic",
    dropLine2: "para subir logo",
    changeLogo: "Cambiar logo",
    selectLogo: "Seleccionar logo",
    uploading: "Subiendo…",
    saveLogo: "Guardar logo",
    removeLogo: "Eliminar logo",
    primaryColor: "Color principal",
    primaryColorHelp: "Afecta al sidebar, botones y elementos de acento de toda la interfaz.",
    customColor: "Color personalizado",
    preview: "Vista previa",
    primaryButton: "Botón primario",
    activeElement: "Elemento activo",
    saving: "Guardando…",
    saveColor: "Guardar color",
    resetTitle: "Restablecer por defecto",
    resetHelp: "Vuelve al logo y color estándar de HelixScan.",
    resetButton: "Restablecer por defecto",
  },
};
